import { isHeoManager, isUAMUser, isUWUser, isUnderwritingUser } from '@/utils/user'

const heoAllowedTypes = [
  'debt-service-coverage-ratio',
  'missing-debt-service-coverage-ratio',
  'dscr',
  'third-lien',
]

export const userHasPermissionToApprove = (user, escalation) => {
  if (!user) return false

  if (user.is_superuser || isUAMUser(user) || isUWUser(user) || isUnderwritingUser(user)) {
    return true
  }

  if (isHeoManager(user)) {
    return heoAllowedTypes.includes(escalation?.type)
  }

  return false
}
